import * as React from "react"
import { Popover as PopoverPrimitive } from "radix-ui"

import { cn } from "../../../lib/utils"
import { useOverlayLock, guardWhenLocked, OVERLAY_LOCKED_CLASSES } from "../../../providers/overlay-lock-provider"

function Popover(props: React.ComponentProps<typeof PopoverPrimitive.Root>) {
  return <PopoverPrimitive.Root data-slot="popover" {...props} />
}

function PopoverTrigger(
  props: React.ComponentProps<typeof PopoverPrimitive.Trigger>,
) {
  return <PopoverPrimitive.Trigger data-slot="popover-trigger" {...props} />
}

function PopoverAnchor(
  props: React.ComponentProps<typeof PopoverPrimitive.Anchor>,
) {
  return <PopoverPrimitive.Anchor data-slot="popover-anchor" {...props} />
}

function PopoverContent({
  className,
  align = "center",
  sideOffset = 4,
  inert,
  "aria-busy": ariaBusy,
  onEscapeKeyDown,
  onInteractOutside,
  ...props
}: React.ComponentProps<typeof PopoverPrimitive.Content>) {
  const isLocked = useOverlayLock()
  return (
    <PopoverPrimitive.Portal>
      <PopoverPrimitive.Content
        data-slot="popover-content"
        align={align}
        sideOffset={sideOffset}
        {...props}
        // Lock attrs after `{...props}` so consumers cannot re-enable a locked overlay.
        inert={isLocked || inert}
        aria-busy={isLocked || ariaBusy}
        onEscapeKeyDown={guardWhenLocked(isLocked, onEscapeKeyDown)}
        onInteractOutside={guardWhenLocked(isLocked, onInteractOutside)}
        className={cn(
          "z-(--z-modal) w-72 origin-(--radix-popover-content-transform-origin) rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none",
          "data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95",
          "data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95",
          "data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
          className,
          isLocked && OVERLAY_LOCKED_CLASSES,
        )}
      />
    </PopoverPrimitive.Portal>
  )
}

export { Popover, PopoverTrigger, PopoverAnchor, PopoverContent }
